<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>用户管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>用户管理列表</span>
        </div>
        <!-- <span class="xcx-add left font14" @click="add()">添加资讯</span> -->
      </div>
      <div class="search-box">
        <el-form :inline="true">
          <el-form-item>
            <el-input placeholder="请输入手机号" v-model="search.mobile"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getIndex()" icon="el-icon-search" type="primary">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="getClearIndex()" icon="el-icon-delete" type="info">清空筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" stripe size="small" style="width: 100%" v-loading="loading">
          <el-table-column align="center" prop="id" label="UID" width="80"></el-table-column>
          <el-table-column prop="nickname" label="姓名" width="200"></el-table-column>
          <el-table-column align="center" prop="mobile" label="手机号" width="120"></el-table-column>
          <el-table-column align="center" label="课程" width="100">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="course(scope.row.id)">{{ scope.row.course }}</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="套餐" width="100">
            <template #default="scope">
              <el-button size="mini" type="danger" @click="package(scope.row.id)">{{ scope.row.package }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="备注" width="*">
            <template #default="scope">
              <el-tag class="mar_B_10" closable type="warning" v-for="(item, index) in scope.row.vip" :key="index"
                @close="cannelVip(item.id)">
                {{ item.column_name }}会员卡：{{ item.vip_time }}到期
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="created_at" width="160" label="注册时间"></el-table-column>
          <el-table-column align="center" label="会员权限" width="140">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="setVip(scope.row)">开通/延长会员</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="300">
            <template #default="scope">
              <el-button size="mini" type="success" @click="record(scope.row.id)">做题记录</el-button>
              <el-button size="mini" type="primary" @click="buy(scope.row.id)">购买记录</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">重置密码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加学员 -->
    <el-dialog title="开通/延长会员" width="28%" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="科目：" :label-width="formLabelWidth" prop="column_ary">
          <el-cascader :props="{ label: 'title', 'value': 'id', 'children': 'childs' }" placeholder="试试搜索：一建" filterable
            clearable v-model="ruleForm.column_ary" :options="LmColumn" @change="handleChange"></el-cascader>
        </el-form-item>
        <el-form-item label="时长：" :label-width="formLabelWidth" prop="etime">
          <el-date-picker v-model="ruleForm.etime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      loading: true,
      tableData: [],
      LmColumn: [],
      formLabelWidth: "80px",
      page: 0,
      count: 0,
      limit: 10,
      search: {
        mobile: "",
      },
      ruleForm: {
        id: 0,
        column_ary: "",
        etime: "",
      },
      rules: {
        column_id: [
          { required: true, message: "请选择科目", trigger: "change" },
        ],
        etime: [{ required: true, message: "请选择时间", trigger: "change" }],
      },
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    getIndex() {
      this.getList();
    },

    getClearIndex() {
      this.search.mobile = "";
      this.getList();
    },

    // 编辑格式化地址
    handleChange(value) { },

    setVip(row) {
      this.ruleForm.desc = row.truename;
      this.ruleForm.id = row.id;
      this.dialogFormVisible = true;
      this.getCate();
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/setAddVip";
        that.axios.post(url, formData).then(() => {
          that.$message.success("添加成功");
          that.dialogFormVisible = false;
          that.ruleForm.id = 0;
          that.ruleForm.column_ary = "";
          that.ruleForm.etime = "";
          that.getList();
        });
      });
    },

    course(ids) {
      this.$router.push({
        path: "/users/course",
        query: {
          uid: ids,
        },
      });
    },

    package(ids) {
      this.$router.push({
        path: "/users/package",
        query: {
          uid: ids,
        },
      });
    },

    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    cannelVip(ids) {
      let that = this;
      this.$confirm(
        "确定要移除此会员的vip权限吗？ 此操作不可逆, 是否继续?",
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        that.axios.post("/setCancelVip", { id: ids }).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            that.getList();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        });
      });
    },

    getCate() {
      var that = this;
      that.axios.post("/getColumn").then((res) => {
        if (res) {
          that.LmColumn = res.data;
        }
        that.loading = false;
      });
    },

    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.mobile = that.search.mobile;
      that.axios.post("/getYtkUsers", formData).then((res) => {
        if (res) {
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
          that.loading = false;
        }
      });
    },
  },
};
</script>
<style></style>